import React from 'react';
import CRUDView, {CustomFilterFrame} from "../../../../components/CRUDView";
import AppVariables from "../../../../common/AppVariables";
import Utils, {exportFilteredCSV} from "../../../../common/Utils";
import {OwnerPaymentStatusMap, Permissions, TractorOwnerRequestPaymentStatus} from "../../../../common/Constants";
import {
    FarmersEndpoints,
    PaymentsEndpoints,
    TractorOperatorEndpoint,
    TractorOwnerEndpoints,
    TractorsEndpoints
} from "../../../../common/ProxyEndpoints";
import {Badge, Col, Row} from "reactstrap";
import StandardValue from "../../../../common/StandardValue";
import {CustomPayoutsFilters, parsePayoutFilters, PaymentStatusBadge, PAYOUTS_FILTERS} from "./PayoutsCommon";
import {TimeRangeInfo, TimeRangeSelectionDialog} from "../../../Request/RequestCommon";
import MakePaymentDialog from "./MakePaymentDialog";
import {ExpanderView, SectionedList} from "../../../../components/AuditExplorer/Elements";
import CurrencyLabel from "../../../../components/CurrencyLabel/CurrencyLabel";
import Icon from 'react-icons-kit';
import {ic_account_balance_wallet} from 'react-icons-kit/md/ic_account_balance_wallet';
import {ic_assignment} from 'react-icons-kit/md/ic_assignment';
import NumberLabel from "../../../../components/NumberLabel/NumberLabel";

//  Define properties which are searchable
const SearchProps = [
    'local_reference' ,
    'external_reference',
    'receiver_account_name',
    'receiver_account_no',
    'tractor_request.order_id',
    'amount'
];

class TractorOwnerPayouts extends CRUDView {

    constructor(props) {
        super(props,'tractor_owner_payouts');
    }

    onExecuteRequest(url,params,{ filters }){

        const qs = params.query || (params.query = {});
        const {
            timeFrame,
            timeRangeStart,
            timeRangeEnd
        } = filters;

        if(timeFrame){

            qs.filter_time_range = timeFrame;

            if(timeRangeStart)
                qs.range_from = timeRangeStart.toJSON();

            if(timeRangeEnd)
                qs.range_to = timeRangeEnd.toJSON();
        }

    }

    getCustomFilterState(filters) {
        return parsePayoutFilters(filters);
    }

    beginShowCreate() {
        this._makePaymentDlg.show();
    }

    /**
     * Sets the time range to display
     */
    setTimeRangeDisplay(opts){

        //
        const _update = {
            timeFrame: opts.range,
            timeRangeStart: opts.start ? opts.start.toJSON() : null,
            timeRangeEnd: opts.end ? opts.end.toJSON() : null
        };

        //
        this.setQueryFiltersRaw(filters => ({ ...filters, ..._update }));
    }

    renderDialogs(dialog) {

        const timeRangeInfo = this.state.timeRangeInfo || {};

        return <React.Fragment>

            {super.renderDialogs(dialog)}

            <MakePaymentDialog ref={r => this._makePaymentDlg = r}
                               onExit={paymentResult => {

                                    if(paymentResult){
                                        this.refresh();
                                    }

                               }}/>

            <TimeRangeSelectionDialog ref={r => this._timeRangeSelectionDlg = r}
                                      from={timeRangeInfo.start}
                                      to={timeRangeInfo.end}
                                      onApply={({ start , end }) => {

                                          this.setTimeRangeDisplay({
                                              range: "custom",
                                              start,
                                              end
                                          });

                                      }}/>
        </React.Fragment>
    }

    componentWillMount(){

        const me = this;
        this.setViewOptions({

            //  The message to show when there are no items in the view
            noRowsMessage: 'No payments issued yet!',

            //  The class icon for the card header
            pageIcon: 'fa fa-money',

            //  The title for the content frame
            pageTitle: 'Tractor Owner Payouts',

            //  The total number of items per page
            maxItemsPerPage: AppVariables.MaxItemsPerPage,

            //  Defines the features of the view
            features: [ 'toolbox' , 'search' ],

            multiSelection: {

                //  enable multi-selection
                enable : false,
            },

            hooks:{


            },

            //  defines (CRUD) actions enabled on the items
            actions:{

                //  create action options
                create: {
                    enabled: true,
                    text: 'Make Payment',
                    successCreateMsg: 'Payment issued successfully!',
                    failCreateMsg : 'Failed issuing payment!',
                    editTitleMsg: 'Edit Payment',
                    createTitleMsg: 'Add Payment',
                    permissions:  [ Permissions.Payments.Issue ]
                },

                //  delete action options
                delete:{
                    enabled : false,
                },

                //  edit options
                edit:{
                    enabled : false
                }

            },

            queryActions: {

                //  The endpoint for query actions
                endpoint: PaymentsEndpoints.getUrl()
            },

            model: {
                include: [ 'admin', 'tractor_request' , 'owner' , 'wallet' ]
            },

            inputs: [],

            filters: PAYOUTS_FILTERS,

            renderCustomFilters: (props) => <CustomPayoutsFilters fetchFarmers={async params => (await me.execReq(FarmersEndpoints.getUrl(),params)).getPayload()}
                                                                  fetchTractors={async params => (await me.execReq(TractorsEndpoints.getUrl(),params)).getPayload()}
                                                                  fetchOperators={async params => (await me.execReq(TractorOperatorEndpoint.getUrl(),params)).getPayload() }
                                                                  fetchOwners={async params => (await me.execReq(TractorOwnerEndpoints.getUrl(),params)).getPayload() }
                                                                  {...props}/>,

            search:{

                //
                placeholder: 'Search payments...',

                //  the mode for searching
                //  immediate: responsive
                //  explicit: wait till user hits the search button
                mode: 'explicit',

                //  The minimum characters to begin search with
                minSearchChars: 2,

                //  Search properties
                properties: SearchProps

            },

            //  Defines actions for toolbox
            toolBox: [
                {  text : 'Make Payment'  , icon : 'fa fa-plus'  , className: "btn-green"  , invoke: () => this.beginShowCreate()  , position: 'right' , permissions: [ Permissions.Payments.Issue] },
                {  text : 'Refresh'  , icon : 'fa fa-refresh'  , invoke: () => me.refresh() , position: 'right' },
                {  text : 'Status', icon: 'fa fa-signal'  , invoke: (index) => { me.updateQuery('status', TractorOwnerRequestPaymentStatus[OwnerPaymentStatusMap[index]] ) }, position: 'right' , group : 'status-filter' , items: OwnerPaymentStatusMap },
                {
                    text: '', icon: 'fa fa-calendar',   items: Object.keys(TimeRangeInfo).map(x => TimeRangeInfo[x].label), position: 'left' , style: { marginRight: 10 } , invoke: index => {

                        let timeFrame = Object.keys(TimeRangeInfo)[index];
                        if (timeFrame === "custom") {

                            const filters = this.getQueryFilters();

                            //  show dialog for selecting time range
                            this._timeRangeSelectionDlg.show({
                                start: filters.timeRangeStart,
                                end: filters.timeRangeEnd
                            });

                            //  prevent selection of item
                            return false;

                        } else {
                            this.setTimeRangeDisplay({
                                range: timeFrame
                            });
                        }

                    }

                },
                {  text : ''  , icon : 'fa fa-gears' , invoke: (index) => {

                        switch (index){
                            case 0:
                                return exportFilteredCSV(PaymentsEndpoints.exportCSV(),{ component: me });
                            case 1:
                                return  me.toggleCustomFilterVisibility();
                        }

                    }, position: 'right' , group : 'more' ,
                    items: () => ([
                        <span><i className="fa fa-file-text"/> Export to CSV</span>,
                        <span><i className={me.isCustomFilterViewVisible() ? "fa fa-chevron-up" : "fa fa-chevron-down"}/> {me.isCustomFilterViewVisible() ? "Hide" : "Show"} Advanced Filters</span>
                    ]),
                    sticky: false,
                }
            ],

            // Describes the columns present in the table
            columns : [
                {   key: 'local_reference', label: () => me.sortCol("Transaction Id","local_reference")},
                {   key: 'tractor_request', label: 'Request ID' , format: (request) => request.order_id , mobile: true },
                {   key: 'owner', label: () => me.sortCol("Receiver","owner") , cell: (item,key) => item.owner.name , mobile: true },
                {   key: 'amount', label: () => me.sortCol("Amount","amount"), format: 'money', mobile: true },
                {   key: 'status', label: () => me.sortCol("Status","status"), cell: (item,key) => <PaymentStatusBadge payment={item}/>, mobile: true },
                {   key: 'date_created', label: () => me.sortCol("Time Issued","date_created"), format: 'date', mobile: true },
            ],

            //  Describes details to show when clicked
            detailsDisplay: {

                //  enable or disable
                enabled: true,
                large: true,
                renderTitle: () => "Payment Info",

                customRender: (item) => {

                    const me = this;

                    return <div>

                        <CustomFilterFrame>
                            <Row>

                                <Col md={4}>

                                    <div className="text-center mt-4">
                                        {item.status === TractorOwnerRequestPaymentStatus.Success &&  <Badge pill color="success">Succeeded</Badge>}
                                        {item.status === TractorOwnerRequestPaymentStatus.Failed &&  <Badge pill color="warning">Failed</Badge>}
                                        {item.status === TractorOwnerRequestPaymentStatus.Cancelled &&  <Badge pill color="danger">Cancelled</Badge>}
                                        <p><span style={{ fontSize: "3.2em" }}><NumberLabel value={item.amount}/></span> <b>{item.currency}</b></p>
                                    </div>

                                </Col>

                                <Col md={6}>
                                    <ExpanderView title={<span><i className="fa fa-user"/> Tractor Owner</span>} isExpanded>

                                        <SectionedList items={[
                                            {
                                                title: "Name",
                                                value: item.owner.name
                                            },
                                            {
                                                title: "Phone",
                                                value: item.owner.user.phone
                                            },
                                            {
                                                title: "Email",
                                                value: <StandardValue value={item.owner.user.email}/>
                                            }
                                        ]}/>

                                    </ExpanderView>
                                </Col>

                            </Row>
                        </CustomFilterFrame>

                        <hr/>



                        {item.wallet && <ExpanderView title={<span><Icon icon={ic_account_balance_wallet}/> Wallet</span>}>

                            <SectionedList items={[
                                {
                                    title: "Name",
                                    value: item.wallet.name
                                },
                                {
                                    title: "Provider",
                                    value: item.wallet.provider
                                },
                                {
                                    title: "Info (Value)",
                                    value: item.wallet.value
                                }
                            ]}/>

                        </ExpanderView>}

                        <ExpanderView title={<span><Icon icon={ic_assignment}/> Request Info</span>}>

                            <SectionedList items={[
                                {
                                    title: "Service",
                                    value: item.tractor_request.service.name
                                },
                                {
                                    title: "Location",
                                    value: item.tractor_request.location
                                },
                                {
                                    title: "Cost",
                                    value: <CurrencyLabel value={item.tractor_request.cost} currency={item.tractor_request.currency}/>
                                },
                                {
                                    title: "Quantity",
                                    value: `${item.tractor_request.hectares} ${Utils.pluralize(item.tractor_request.hectares,item.tractor_request.service.unit_name.toLowerCase())}`
                                }
                            ]}/>

                        </ExpanderView>

                        <ExpanderView title={<span><i className="fa fa-money"/> Payment Info</span>}>

                            <SectionedList items={[
                                {
                                    title: "Transaction ID",
                                    value: item.local_reference
                                },
                                {
                                    title: "Amount",
                                    value: <CurrencyLabel value={item.amount} currency={item.currency}/>
                                },
                                {
                                    title: "External Reference",
                                    value: item.external_reference
                                },
                                {
                                    title: "Status Message",
                                    value: item.payment_status_message,
                                    mode: "vertical"
                                },
                                {
                                    title: "Time Issued",
                                    value: Utils.formatDateStandard(item.date_created)
                                },
                                {
                                    title: "Time Completed",
                                    value: item.date_completed ? Utils.formatDateStandard(item.date_completed) : "NOT YET"
                                },
                                {
                                    title: "Acknowledgment Status",
                                    value: item.time_acknowledged ? <span><i className="fa fa-check" style={{ color: "green" }}/> ACKNOWLEDGED</span> : "NOT YET"
                                }
                            ]}/>

                        </ExpanderView>

                        <ExpanderView title={"Issued By (Administrator)"}>
                            <SectionedList items={[
                                {
                                    title: "Name",
                                    value: item.admin.name
                                },
                                {
                                    title: "Email",
                                    value: item.admin.user.email
                                },
                                {
                                    title: "Phone",
                                    value: item.admin.user.phone
                                }
                            ]}/>
                        </ExpanderView>

                    </div>
                }
            },

            //  Processors
            processors :{

                //  create new item
                createItem: (proxy , payload) => {
                },

                //  on edit item
                onEditItem: (proxy,item, formData, affected ) => {
                },

                //  on delete item
                onDeleteItem: ( proxy,item) => {
                },

                //  called to delete many items
                deleteMany: (proxy,items) => {
                }

            }
        });

    }


}

export default TractorOwnerPayouts;



// WEBPACK FOOTER //
// ./src/views/Extras/Finance/TractorOwnerPayouts/TractorOwnerPayouts.js